// rama-pharma
// export const usePlans = true;
// export const useMaterialsPlan = false;
// export const usePrices = false;
// export const usePricingTypes = false;
// export const showEntityAddressInMenus = false;
// export const addingCustomerDirectly = false;
// export const useFinancialTarget = false;
// export const useNotifications = false;
// export const useDirectEntityModify = false;
// export const useMaterialsSpecialtyVisits = false;
// export const deletionExternal = false;
// export const enableVacations = true

// ibn-alhaytham
export const usePlans = true;
export const useMaterialsPlan = false;
export const usePrices = false;
export const usePricingTypes = false;
export const showEntityAddressInMenus = false;
export const addingCustomerDirectly = false;
export const useFinancialTarget = false;
export const useNotifications = false;
export const useDirectEntityModify = false;
export const useMaterialsSpecialtyVisits = false;

// new config
export const enableVacations = true

export const deletionExternal = true